export default "__VITE_ASSET__DE5kShMx__"